import React from 'react';
import { IconText } from '@wienenergiegithub/ui-next';

const ProductCardTarifInfos = ({ tarifCardInfo }) => (
  <IconText
    glyph={tarifCardInfo.icon ? tarifCardInfo.icon : 'info-circle'}
    hasBackground
    hasBorder
    heading={tarifCardInfo.title}
    iconTheme="secondary"
    text={tarifCardInfo.text}
    variant="inline"
  />
);

export default ProductCardTarifInfos;
